import React from 'react';
import { Typography } from '@deeptrue-frontend/ui';
import { compose } from 'ramda';
import Grid from '@material-ui/core/Grid';
import Forms from 'components/Forms';
import { useFormatMessage } from 'components/IntlProvider';
import { OrganizationType } from 'store/modules/auth/auth';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { withMetaDescription } from 'components/HeadProvider/HeadProvider';
import styled from 'styled-components/macro';

const { connect, selectors } = StoreProvider;

const StyledDescription = styled(Typography)`
  font-size: 0.875rem;
`;

const StyledTitle = styled(Typography)`
  font-size: 1.125rem;
  font-weight: 500;
`;

interface InviteRepondentProps {
  organization: OrganizationType;
  uuid: string;
  codename: string;
  setRespondentsAdded: (val: boolean) => void;
}

const ProjectInviteCSVRespondents = ({
  organization,
  uuid,
  codename,
  setRespondentsAdded,
}: InviteRepondentProps) => {
  const t = useFormatMessage();
  const organizationCodename = codename || organization.codename;

  return (
    <Grid container>
      <Grid item xs={12}>
        <StyledTitle variant="h6">
          {t('project.collectData.manual.CSVFile.title', 'CSV file')}
        </StyledTitle>
        <StyledDescription mb="0.875rem">
          {t(
            'project.collectData.manual.CSVFile.desc',
            'You can also upload CSV file with the emails. '
          )}
        </StyledDescription>

        <Forms.UploadPanelistCSV
          organizationCodename={organizationCodename}
          uuid={uuid}
          setRespondentsAdded={setRespondentsAdded}
        />
      </Grid>
    </Grid>
  );
};

export default compose(
  connect((state) => ({
    organization: selectors.authSelectors.userOrganization(state),
  })),
  withMetaDescription({ title: 'Dashboard projects' })
)(ProjectInviteCSVRespondents);
